const useLayoutStyles = () => {
    return {
        layoutContainerStyles: {
            maxWidth: 1728,
            width: '100%'
        },
        mainContentContainerStyles: {
            px: 5,
            width: '100%'
        }
    };
};
export default useLayoutStyles;
